import "babel-polyfill";
import Choices from 'choices.js';
import dompolyfill from './modules/dom-polyfill.js';
import RefineSearch from './modules/refine-filters.js'
import attachOnSelectChangeUrlHandler from './modules/search-result-sort.js'
import utils from './modules/utils.js';
import GliderCarousel from './modules/glider-carousel.js'
import DatePicker from './modules/date-picker.js';
import BzAdPage from './modules/bz-ads.js';
import Header from './modules/header.js';
import RecentNotices from './modules/recent-notices.js';
import './modules/modal'

import {
  SHOW_MENU_CLASS,
  SHOW_SEARCH_CLASS,
  SHOW_REFINEMENT_CLASS,
  refineEl,
  drawerEl,
  refineCloseEl,
  searchInputButtonEl,
  searchCloseEl,
  searchInputEl,
  formExpandEl,
  mobileSearchTitleEl,
  mobileSearchInputEl,
  closeMobileFormEl,
  searchFormEl,
  searchIconEl,
  documentBodyEl,
  publicationEl
  } from './modules/constants.js'

dompolyfill();

document.addEventListener("DOMContentLoaded", () => {
  init();
});

var init = function() {

    const topPicksEl = document.getElementById("glider-top");
    if(topPicksEl) {
      // Create Mobile Top Picks Carousel
      const gliderArrowsEl = document.getElementsByClassName('glider__controller'),
      gliderDotsEl = '#dots',
      gliderArrowPrev = '#glider__prev-control',
      gliderArrowNext = '#glider__next-control',
      topPickCardEl = document.getElementsByClassName('glider-slide');

      new GliderCarousel(topPicksEl, gliderArrowsEl, gliderDotsEl, gliderArrowPrev, gliderArrowNext, topPickCardEl);
    }

    const featuredEl = document.getElementById("glider-featured");
    if(featuredEl) {
      // Create Mobile Top Picks Carousel
      const gliderArrowsEl2 = document.getElementsByClassName('glider__controller'),
      gliderDotsEl2 = '#dots2',
      gliderArrowPrev2 = '#glider__prev-control2',
      gliderArrowNext2 = '#glider__next-control2',
      topPickCardEl = document.getElementsByClassName('glider-slide');

      new GliderCarousel(featuredEl, gliderArrowsEl2, gliderDotsEl2, gliderArrowPrev2, gliderArrowNext2, topPickCardEl);
    }
    // Init Header
    new Header(searchInputEl, formExpandEl, mobileSearchTitleEl, mobileSearchInputEl, closeMobileFormEl, searchFormEl, searchIconEl, documentBodyEl);
    // Init Search Refinement Filters
    new RefineSearch(refineEl, refineCloseEl, drawerEl, SHOW_REFINEMENT_CLASS);

    new BzAdPage();

    if(publicationEl) {
      new Choices(publicationEl, {shouldSort: false, itemSelectText: ''});
    }

    attachOnSelectChangeUrlHandler('[data-interaction-sort]');
    attachOnSelectChangeUrlHandler('[data-interaction-per-page]');
    utils();

   var isMobile = {
    Android: function() {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
      return navigator.userAgent.match(/iPhone|iPod/i);
    },
    Opera: function() {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
      return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    },
    any: function() {
      return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
  };

  if (!isMobile.any()) {
    new DatePicker();
  }

    autosize(document.querySelectorAll('textarea'));
    RecentNotices(window.recentNotices || [])

    // Remove preload class to start css animations at the same time
    document.querySelectorAll('.preload').forEach(x => x.classList.remove('preload'));
}
